module.exports = __webpack_public_path__ + "static/media/react-native-white.08d3d82e.png";